import Dexie from "dexie";

export const offlineDB = new Dexie("JobPostingOfflineDB");

offlineDB.version(2).stores({
  jobWizard: "key",
});
